import { useEffect, useState } from 'react';
import { useAtom } from 'jotai';

import { qrInfoErrorAtom } from '../atoms/money-pool-qr/atom';

export const useErrorSreen = () => {
    const [error, setError] = useAtom(qrInfoErrorAtom);
    const [openErrorModal, setOpenErrorModal] = useState(false);

    const handleCloseError = () => {
        setError(null);
        setOpenErrorModal(false);
    };

    useEffect(() => {
        if (error) {
            setOpenErrorModal(true);
        }
    }, [error]);

    return {
        dataTestId: 'transfer-error-sreen',
        resultIcon: {
            backgroundColor: 'graphicColorNegative' as const,
            iconColor: 'graphicColorPrimaryInverted' as const,
            iconName: 'glyph_cross_m',
        },
        paymentTitle: error?.title,
        paymentDescription: error?.subtitle,
        button: {
            title: 'Попробовать снова',
        },
        closeButton: true,
        onClose: handleCloseError,
        open: openErrorModal,
        error: false,
        loading: false,
        direction: 'NON_FINANCIAL',
        type: 'error',
    };
};
